import type { PubSubData } from "@/types";

/**
 * Creates an array of dropdown options with sequential numbers
 * @param start - The starting number of the sequence
 * @param end - The ending number of the sequence
 * @returns Array of dropdown options with text and value
 */
export const createNumberOptions = (start: number, end: number) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, i) => ({
    text: (i + start).toString(),
    value: (i + start).toString(),
  }));
};
/**
 * Generic form update control handler for PubSub events
 * @param data - PubSub data with context and value
 * @param updateForm - Function to update form state
 */
export const createUpdateControl = <T extends Record<string, any>>(
  updateForm: (data: Partial<T>) => void,
) => {
  return (data: PubSubData & { context: keyof T }) => {
    updateForm({ [data.context]: data.value } as Partial<T>);
  };
};
